// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__w6iCl"};